import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlertModel {
  serasaObj;
}

@Component({
  selector: 'app-concentre',
  templateUrl: './concentre.component.html',
  styleUrls: ['./concentre.component.scss']
})
export class ConcentreComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {

  serasaObj = null;
  report = null;
  negativeSummaryRows = [];
  factSummaryRows = [];

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    if (this.serasaObj && this.serasaObj.Registration) {
      this.report = this.serasaObj;
      this.negativeSummaryRows = [
        { label: 'Pendências Comerciais (PEFIN)', group: this.report.NegativeData && this.report.NegativeData.Pefin },
        { label: 'Pendências Bancárias (REFIN)', group: this.report.NegativeData && this.report.NegativeData.Refin },
        { label: 'Protestos', group: this.report.NegativeData && this.report.NegativeData.Notary },
        { label: 'Cheques sem Fundos', group: this.report.NegativeData && this.report.NegativeData.Check },
        { label: 'Registros de Cobrança', group: this.report.NegativeData && this.report.NegativeData.CollectionRecords }
      ];
      this.factSummaryRows = [
        { label: 'Documentos Roubados/Furtados', group: this.report.Facts && this.report.Facts.StolenDocuments },
        { label: 'Ações Judiciais', group: this.report.Facts && this.report.Facts.JudgementFilings },
        { label: 'Falências / Concordatas', group: this.report.Facts && this.report.Facts.Bankrupts }
      ];
    }
  }

  itemCount(group) {
    if (group && group.Summary && group.Summary.Count !== null && group.Summary.Count !== undefined) {
      return group.Summary.Count;
    }
    return group && group.Items ? group.Items.length : 0;
  }

  itemBalance(group) {
    if (group && group.Summary && group.Summary.Balance !== null && group.Summary.Balance !== undefined) {
      return group.Summary.Balance;
    }
    if (!group || !group.Items) return 0;
    return group.Items.reduce((total, item) => total + (item.Amount || 0), 0);
  }

  avalista(item) {
    if (!item || item.Principal === null || item.Principal === undefined) return '—';
    return item.Principal === true ? 'Não' : 'Sim';
  }

  // Só há "detalhe" a exibir quando o grupo tem ocorrência (contagem > 0). Usado para abrir/fechar
  // cada tabela da seção Detalhes — quando não há restritivo daquele tipo, a tabela nem aparece.
  hasDetails(group) {
    return this.itemCount(group) > 0;
  }

  // A seção "Detalhes" inteira só aparece se houver ao menos um tipo com ocorrência.
  hasAnyDetails() {
    if (!this.report) return false;
    const nd = this.report.NegativeData || {};
    const f = this.report.Facts || {};
    return [nd.Pefin, nd.Refin, nd.Notary, nd.Check, nd.CollectionRecords,
            f.JudgementFilings, f.Bankrupts, f.StolenDocuments]
      .some(g => this.itemCount(g) > 0);
  }

  closeModal() {
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/concentre/concentre.component.ts